import React from "react";
import "./index.css";
import boxit from "../../../img/logo-boxit-jpeg.jpg";
import llego from "../../../img/LLEGO_logo.png";
// icons

export default function Home() {
  return (
    <main className="main-container" >
      <div className="d-flex flex-column justify-content-center align-items-center">
        <img src={boxit} alt="Boxit Store" height={60} />
        <div className="main-content-text my-5" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          <p className="mb-0">Recuerda que ahora los servicios de</p>
          <p className="mb-0"><span className="font-weight-bold">compras por internet</span></p>
          <p className="mb-0">son operados por:</p>
        </div>
        <a className="d-flex flex-column justify-content-center align-items-center link-llego" href="https://loquepedi.com">
          <div className="d-flex justify-content-center align-items-center">
            <img src={llego} alt="Llego" height={150} />
          </div>
          loquepedi.com
        </a>
      </div>
    </main>
  );
}
